import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import todo from "../../Assets/Projects/todo-app.jpeg";
import wikipedia from "../../Assets/Projects/wikipedia.jpeg";
import mernblog from "../../Assets/Projects/mern-blog photo.jpeg";
import ecommerce from "../../Assets/Projects/E-commerce.jpeg";
import moneymanager from "../../Assets/Projects/money-manager.jpeg";
import jobportal from "../../Assets/Projects/job-portal.jpeg"
import weather from "../../Assets/Projects/weather-app.jpeg";
import admin from "../../Assets/Projects/admin-dashboard.jpeg";
import hotel from "../../Assets/Projects/hotel-booking.jpeg";
import greencart from "../../Assets/Projects/Green-Cart.jpeg";
import appointment from "../../Assets/Projects/doctor-appointment-booking.jpeg";
import moviebooking from  "../../Assets/Projects/movie-booking-system.jpeg";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={moviebooking}
              isBlog={false}
              title="Movie Ticket Booking Platform"
              description="QuickShow is a full-stack movie ticket booking application built with the MERN stack, designed to provide a smooth and efficient ticket booking experience. It features real-time seat selection, user authentication via Clerk, and a robust backend powered by Inngest for handling asynchronous tasks such as email notifications, booking confirmations, and automated seat release for unpaid bookings. User sign-up/login using Clerk Browse movies and book available showtimes Real-time seat selection and payment flow Automatic booking cancellation after 10 minutes if unpaid Transactional emails: booking confirmation, show reminders, and new show announcements Admin access to add movies, create shows, and monitor bookings"
              ghLink="https://github.com/aggisanjay/QuickShow"
              demoLink="https://quick-show-frontend-delta.vercel.app/"
            />
          </Col> 

           <Col md={4} className="project-card">
            <ProjectCard
              imgPath={appointment}
              isBlog={false}
              title="Doctor Appointment Booking System "
              description="The Doctor Appointment Booking System is a full-stack web application that enables users to seamlessly browse doctor profiles, check real-time availability, and book appointments. The system dynamically generates available time slots for each doctor based on the current date and filters out already booked times to prevent conflicts. Users can view detailed doctor information such as specialization, experience, and consultation fees, and must be authenticated to complete a booking. After booking, the appointment is saved and the user is redirected to their appointments page. Built using React.js, Node.js, Express, and MongoDB, the application features a responsive and user-friendly interface, real-time updates, and secure token-based authentication to ensure a smooth and reliable healthcare scheduling experience."
              ghLink="https://github.com/aggisanjay/doctor-appointment-booking-application"
              demoLink="https://doctor-appointment-booking-application-frontend.vercel.app/"
            />
          </Col> 

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={greencart}
              isBlog={false}
              title="Grocery Store Website"
              description="GreenCart is a full-stack e-commerce web application built to offer a seamless online grocery shopping experience. It features user authentication, product browsing, cart management, and secure order placement. The frontend is developed using React.js for dynamic UI rendering, while the backend is powered by Node.js, Express, and MongoDB, ensuring fast and scalable performance. GreenCart also integrates Stripe for secure payments and uses a custom admin dashboard for managing products and orders. This project demonstrates my ability to build modern, end-to-end web applications with real-world features like API integration, responsive design, and state management"
              ghLink="https://github.com/aggisanjay/GREENCART"
              demoLink="https://greencart-frontend-sandy.vercel.app"
            />
          </Col>
            <Col md={4} className="project-card">
            <ProjectCard
              imgPath={hotel}
              isBlog={false}
              title="Hotel-Booking"
              description="This project is a responsive and dynamic hotel booking platform developed using React.js. It features a clean and modern user interface with a navigation bar that smoothly handles both desktop and mobile views. Users can explore various hotel rooms, access the dashboard, and sign in or register through an intuitive menu. The project implements react-router-dom for seamless client-side routing between pages like Home, Rooms, and Owner Dashboard without page reloads. It ensures a smooth user experience across all devices with carefully handled navigation, state management for menu toggling, and user authentication checks."
              ghLink="https://github.com/aggisanjay/hotel-booking"
              demoLink="https://hotel-booking-frontend-lime.vercel.app"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={jobportal}
              isBlog={false}
              title="Job-portal"
              description="
Job Portal Summary
The job portal project is a full-stack application designed for two types of users: candidates and recruiters. Here are the key features:
User Roles
Candidates:
Create profiles
Upload resumes
Apply for jobs
View job listings with filtering options
Recruiters:
Post job listings
Manage applications
Access candidate profiles
Features
Onboarding Process: Users provide role-specific information.
Authentication: Ensures users access only relevant features.
Membership System: Premium members can post more jobs; non-premium users have limits.
Database: Utilizes MongoDB for storing user profiles and job listings.
Server Actions: Manages data without separate API routes and integrates with clerk for login."
              ghLink="https://github.com/aggisanjay/NextJS-job-portal"
              demoLink="https://next-js-job-portal-murex.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ecommerce}
              isBlog={false}
              title="E-commerce"
              description="I have developed a fully functional e-commerce application that includes key features such as user authentication (login,register), cart management, and payment processing. For the front end, I used React.js and styled it with TailwindCSS. The back end is powered by MongoDB to handle data storage efficiently."
              ghLink="https://github.com/aggisanjay/mern-deploy-ecommerce"
              demoLink="https://mern-deploy-ecommerce-1.onrender.com"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={mernblog}
              isBlog={false}
              title="MERN BLOG"
              description="I developed a fully functional blog application using the MERN stack (MongoDB, Express, React.js, and Node.js). The frontend was built with React.js and styled using Tailwind CSS, ensuring a modern, responsive design. The application allows users to create, edit, and delete posts, with all data securely managed in a MongoDB database. User interactions and post management are handled efficiently through RESTful APIs built with Express and Node.js. This project demonstrates my ability to integrate backend functionality with a dynamic, visually appealing frontend."
              ghLink="https://github.com/aggisanjay/mern-blog"
              demoLink="https://mern-blog-9ik8.onrender.com"              
            />
          </Col>
            <Col md={4} className="project-card">
            <ProjectCard
              imgPath={admin}
              isBlog={false}
              title="Admin-Dashboard"
              description="This project is a modern React-based dashboard application built using Syncfusion React components and Vite for fast performance and seamless user experience. It features dynamic and interactive UI elements such as Kanban boards for task management, data grids for tabular operations, schedulers for event planning, charts for data visualization, and rich form controls like dropdowns, calendars, and text editors. The interface is styled with Tailwind CSS and supports client-side routing using React Router. "
              ghLink="https://github.com/aggisanjay/admin-dashboard"
              demoLink="https://admin-dashboard-delta-six-10.vercel.app"
            />
          </Col>
                
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={weather}
              isBlog={false}
              title="Weather App"
              description="I developed a weather application using React components that allows users to search for cities and view real-time weather data. The app dynamically updates based on user input, providing a seamless and interactive experience. This project highlights my skills in building responsive and data-driven applications with React."
              ghLink="https://github.com/aggisanjay/weather-app-using-react"
              demoLink="https://weather-app-using-react-2-ojxf.onrender.com"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={todo}
              isBlog={false}
              title="Todo App"
              description="I built a persistent to-do application with full CRUD (Create, Read, Update, Delete) functionality to help users track tasks. The list of tasks is displayed using HTML list elements and styled with CSS and Bootstrap for a clean, user-friendly interface. CRUD operations were implemented through JavaScript event listeners, allowing dynamic updates to the UI using DOM manipulation. The application utilizes arrays and objects, with methods for efficient task management. Additionally, I used local storage to ensure that the state of the to-do list persists across page reloads, enhancing the user experience. Technologies used include HTML, CSS, JavaScript, and Bootstrap."
              ghLink="https://github.com/aggisanjay/todo"
              demoLink="https://todo-vert-two.vercel.app"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={moneymanager}
              isBlog={false}
              title="Money Manager"
              description="I created a Money Manager application using React that allows users to track their income and expenses. The app enables users to add transactions by entering a title, amount, and selecting whether it's an income or expense. Each transaction is dynamically updated in the transaction history using React's state management. The app calculates and displays the user's balance, total income, and total expenses in real-time. CRUD operations are efficiently handled, allowing users to delete transactions when needed"
              ghLink="https://github.com/aggisanjay/money-manager"
             demoLink="https://money-manager-blush.vercel.app"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={wikipedia}
              isBlog={false}
              title="Wikipedia"
              description="I developed a dynamic Wikipedia search application using vanilla JavaScript, allowing users to search for articles in real time. The app captures the user's input, triggers the search when the Enter key is pressed, and fetches data from a Wikipedia API. Each search result includes a title, URL, and description, which are dynamically created and displayed in the results section using DOM manipulation."
              ghLink="https://github.com/aggisanjay/wikipedia"
              demoLink="https://wikipedia-sooty.vercel.app/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
